/**
 * @flow
 *
 * @format
 */
import UserDetailsScreen from './UsersDetailsScreen';

export default UserDetailsScreen;
